(ns teamoesterreich.admin-mode.modal.enter-amount-modal
  (:require [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left  :refer [keyboard-arrow-left]]
            ))


(defn modal_ [!show message ok-message on-ok-fn &[on-cancel-fn]]
  (let [!amount (r/atom nil)]
    (fn []
      [mui/modal
       {
        :aria-labelledby "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style {:display "flex"
                :marginRight "auto"
                :marginLeft "auto"
                :alignItems "center"
                :justifyContent "center"}
        :open (or @!show false)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4  message]

        [mui/text-field
         {:onChange (fn [e] (reset! !amount (h/event-value e)))
          :type "number"
          }]

        [:br]
        [:br]
        [mui/button
         {:color "primary"
          :variant "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style {:marginRight 50}
          :onClick (fn []
                     (if on-cancel-fn
                       (on-cancel-fn)
                       (reset! !show false)))
          }
         "Abbrechen"]
        [mui/button
         {:style {:float "right" }
          :variant "contained"
          :disabled (if (nil? @!amount) true false)
          :startIcon (r/as-element [done])
          :onClick (fn []
                     (on-ok-fn (js/parseInt @!amount))
                     (reset! !show false))
          }
         ok-message]]
       ]
      )))


(defn modal [!show message ok-message on-ok-fn & [on-cancel-fn]]
  (modal_ !show message ok-message on-ok-fn on-cancel-fn))